<script>
	import SmartLink from '../helpers/SmartLink.svelte';
	import IconSocialsLinkedin from "../images/icons-socials/IconSocialsLinkedin.svelte";
	import IconSocialsXing from "../images/icons-socials/IconSocialsXing.svelte";
	import IconSocialsFacebook from "../images/icons-socials/IconSocialsFacebook.svelte";
	import IconSocialsInstagram from "../images/icons-socials/IconSocialsInstagram.svelte";
	import NavListElement from "../helpers/NavListElement.svelte";
</script>

<footer>
	<ul class="footer--list--desktop">
		<NavListElement url="/impressum" text="Impressum"/>
		<NavListElement url="/datenschutz" text="Datenschutz"/>
	</ul>
	<ul class="footer__list__socials">
		
		<li>Folge uns:</li>
		<li class="socials">
			<a aria-label="Facebook" on:click|stopPropagation={() => {}} href="https://de-de.facebook.com/BurgEins" target="_blank">
				<IconSocialsFacebook/>
			</a>
		</li>
		<li class="socials">
			<a aria-label="Instagram" on:click|stopPropagation={() => {}} href="https://www.instagram.com/burgeins" target="_blank">
				<IconSocialsInstagram/>
			</a>
		</li>
		<li class="socials">
			<a aria-label="LinkedIn" on:click|stopPropagation={() => {}} href="https://de.linkedin.com/company/burgeins" target="_blank">
				<IconSocialsLinkedin/>
			</a>
		</li>
		<li class="socials">
			<a aria-label="Xing" on:click|stopPropagation={() => {}} href="https://www.xing.com/pages/burgeinsgmbh" target="_blank">
				<IconSocialsXing/>
			</a>
		</li>
	</ul>
</footer>

<style lang="scss">
	@import "../style/variables";
	@import "../style/mixins";
	
	footer {
		display: flex;
		position: relative;
		bottom: 0;
		width: 100%;
		font-weight: normal;
		text-transform: uppercase;
		padding: 0 3em 2em;
		white-space: nowrap;
		
		@include for-tablet-landscape-up {
			padding: 0 4rem 5rem px-to-em(142);
		}
		
		@include for-desktop-up {
			padding: 0 9.9rem 5rem 9.9rem;
		}
		
		ul {
			position: relative;
			list-style: none;
			padding: 0;
			display: inline-flex;
			gap: px-to-em(25);
			
			&.footer--list--desktop {
				align-items: flex-start;
				display: none;
				
				@include for-tablet-landscape-up {
					display: flex;
				}
				
				:global(li) {
					color: rgba(255, 255, 255, 0.65);
					transition: color .2s ease-in-out;

					@include for-tablet-landscape-up {
						padding-right: 2em;
					}
				}

				:global(li.active), :global(li:hover) {
					color: white !important;
				}
			}
			
			&.footer__list__socials {
				width: 100%;
				justify-content: space-between;
				
				@include for-tablet-landscape-up {
					width: 45%;
					max-width: 290px;
				}
				
				li {
					&:nth-of-type(1) {
						font-weight: 600;
					}

					&.socials :global(path) {
						fill: white;
					}
				}
			}
			
			:global(li), :global(a) {
				@include font-px-to-rem(22, 40, 100);
			}
		}
	}
</style>
